import { ref } from 'vue';

const defaultState = () => ({
  id: null,
  title: '',
  slug: '',
  description: '',
  url: '',
  tags: ref([]),
  cost: 0,
  campaignType: null,
  causes: ref([]),
  maxQuantity: 0,
  maxDonation: null,
  donationMultiplier: 1,
  impact: null,
  startDate: null,
  endDate: null,
  eventDate: null,
  startDateTimeZone: null,
  endDateTimeZone: null,
  eventDateTimeZone: null,
  waiverURL: '',
  varients: [],
  location: null,
  status: null,
  bannerUrl: null,
  locationType: null,
  virtualLink: null,
  hideLocation: false,
  addOns: [],
  gallery: [],
  faqs: [],
  quickCosts: [null, null, null, null],
  glow: {
    glowStartDate: null,
    glowEndDate: null,
    glowColor: null,
    glowStartDateTimeZone: null,
    glowEndDateTimeZone: null,
  },
  isFeatured: null,
  sweepstakesSticker: {
    aboutTheCause: null,
    approximateRetailValue: null,
    checkoutPageLegal: null,
    createdAt: null,
    drawingDateTime: null,
    drawingDateTimeTimezone: null,
    drawnAt: null,
    entries: [null],
    entryCost: [null],
    experienceDateTime: null,
    experienceDateTimeTimezone: null,
    nonProfitBeneficiary: null,
    numberOfPrizesAndWinners: null,
    prizes: null,
    sweepstakesConfirmation: null,
    sweepstakesLoserMessage: null,
    sweepstakesWinnerMessage: null,
  },
  getSweepstakesWinners: ([{
    id: null,
    stickerId: null,
    entityId: null,
    participantName: null,
    participantAvatar: null,
    eligible: null,
  }]),
  confirmationEmail: null,
  reminderEmail: null,
  isWinnerConfirmed: null,
});

export default {
  namespaced: true,

  state: {
    item: defaultState(),
    publishedStickers: null,
    purchasedStickers: null,
  },

  mutations: {
    MUTATE_STICKER(state, payload) {
      Object.assign(state.item, payload);
    },
    SET_PUBLISHED_STICKERS(state, stickers) {
      state.publishedStickers = stickers;
    },
    SET_PURCHASED_STICKERS(state, stickers) {
      state.purchasedStickers = stickers;
    },
  },

  actions: {
    SET_STICKER({ commit }, item) {
      commit('MUTATE_STICKER', item);
    },
    RESET_TO_DEFAULT({ commit }) {
      commit('MUTATE_STICKER', defaultState());
    },
    SET_PUBLISHED_STICKERS({ commit }, stickers) {
      commit('SET_PUBLISHED_STICKERS', stickers);
    },
    SET_PURCHASED_STICKERS({ commit }, stickers) {
      commit('SET_PURCHASED_STICKERS', stickers);
    },
  },

  getters: {
    GET_STICKER: (state) => state.item,
    GET_PUBLISHED_STICKERS: (state) => state.publishedStickers || [],
    GET_PURCHASED_STICKERS: (state) => state.purchasedStickers || [],
    HAS_FETCHED_PUBLISHED_STICKERS: (state) => state.publishedStickers !== null,
    HAS_FETCHED_PURCHASED_STICKERS: (state) => state.purchasedStickers !== null,
  },
};
